import Icon from '../components/Icon.vue'

Icon.register({
  'money-bill-wave': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M621.2 54.5C582.4 38.2 543.5 32 504.8 32 381.6 32 258.4 94.3 135.3 94.3 104.4 94.3 73.5 90.4 42.6 80.6 39.1 79.5 35.6 79 32.3 79 15 79 0 92.3 0 110.8V428.1C0 440.7 7.2 452.7 18.8 457.5 57.6 473.8 96.5 480 135.3 480 258.4 480 381.6 417.6 504.8 417.6 535.6 417.6 566.5 421.6 597.4 431.4 600.9 432.5 604.4 433 607.8 433 625 433 640 419.7 640 401.2V83.9C640 71.3 632.8 59.3 621.2 54.5zM48 132.2C68.1 137.3 89.1 139.8 110.7 141.1 104.8 170.5 79 192.7 48 192.7V132.2zM48 417.2V369.4C82.4 369.4 110.2 396.7 111.7 430.8 89.2 429 68.1 424.5 48 417.2zM320 352C275.8 352 240 309 240 256 240 203 275.8 160 320 160S400 203 400 256C400 309 364.2 352 320 352zM592 379.8C574.5 375.4 556.3 372.9 537.7 371.3 543.5 345.3 565.2 325.5 592 322.1V379.8zM592 143.7C561.1 139.8 537.1 114 536.2 82.1 555.7 84.3 574.3 88.3 592 94.8V143.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/money-bill-wave.js
// module id = 4emP
// module chunks = 144